var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import * as React from 'react';
import { Pagination as CorePagination } from 'wix-ui-core/dist/es/src/components/pagination';
import DoubleChevronLeft from 'wix-ui-icons-common/on-stage/DoubleChevronLeft';
import DoubleChevronRight from 'wix-ui-icons-common/on-stage/DoubleChevronRight';
import ChevronLeft from 'wix-ui-icons-common/on-stage/ChevronLeft';
import ChevronRight from 'wix-ui-icons-common/on-stage/ChevronRight';
import { TPAComponentsConsumer } from '../TPAComponentsConfig';
import { st, classes } from './Pagination.st.css';
/** Pagination component */
export var Pagination = function (props) {
    return (React.createElement(TPAComponentsConsumer, null, function (_a) {
        var mobile = _a.mobile, rtl = _a.rtl;
        return (React.createElement(CorePagination, __assign({ previousLabel: React.createElement(ChevronLeft, null), nextLabel: React.createElement(ChevronRight, null), firstLabel: React.createElement(DoubleChevronLeft, null), lastLabel: React.createElement(DoubleChevronRight, null), rtl: rtl, showFirstLastNavButtons: props.totalPages > props.maxPagesToShow, paginationMode: mobile ? 'compact' : 'pages', slashLabel: '/' }, props, { className: st(classes.root, { mobile: mobile, rtl: rtl }, props.className) })));
    }));
};
Pagination.displayName = 'Pagination';
Pagination.defaultProps = {
    maxPagesToShow: 5,
};
//# sourceMappingURL=Pagination.js.map